// src/pages/admin/DashboardHome.jsx
import React from 'react';

const DashboardHome = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Bienvenue dans l’espace Admin</h1>
      <p className="mt-2 text-gray-600">Utilisez le menu pour gérer les clients et les publications.</p>
    </div>
  );
};

export default DashboardHome;
